var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8C0.5 9.10457 1.39543 10 2.5 10C3.60457 10 4.5 9.10457 4.5 8C4.5 6.89543 3.60457 6 2.5 6C1.39543 6 0.5 6.89543 0.5 8Z",
    fill: "#181818"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8.04004C6.5 9.14461 7.39543 10.04 8.5 10.04C9.60457 10.04 10.5 9.14461 10.5 8.04004C10.5 6.93547 9.60457 6.04004 8.5 6.04004C7.39543 6.04004 6.5 6.93547 6.5 8.04004Z",
    fill: "#181818"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.08008C12.5 9.18465 13.3954 10.0801 14.5 10.0801C15.6046 10.0801 16.5 9.18465 16.5 8.08008C16.5 6.97551 15.6046 6.08008 14.5 6.08008C13.3954 6.08008 12.5 6.97551 12.5 8.08008Z",
    fill: "#181818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionsIcon);
export default __webpack_public_path__ + "static/media/OptionsIcon.4629b2fe01ecab4e21919b4f749cb29e.svg";
export { ForwardRef as ReactComponent };